import { c as _c } from "react/compiler-runtime";
import { useParams } from "next/navigation";
import { startTransition, useActionState } from "react";
import type z from "zod";
import { ferdigstillPlanServerAction } from "@/server/actions/ferdigstillPlan";
import type { ferdigstillPlanActionPayloadSchema } from "@/server/actions/serverActionsInputValidation";
import type { FetchUpdateResult } from "@/server/tokenXFetch/FetchResult";
export type FerdigstillPlanActionPayload = z.infer<typeof ferdigstillPlanActionPayloadSchema>;
export default function useFerdigstillOppfolgingsplanAction() {
  const $ = _c(7);
  const {
    narmesteLederId
  } = useParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      error: null
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const initialFerdigstillState = t0;
  const [t1, ferdigstillPlanAction, isPendingFerdigstillPlan] = useActionState(innerFerdigstillPlanAction, initialFerdigstillState);
  const {
    error
  } = t1;
  function innerFerdigstillPlanAction(_previousState, payload) {
    return ferdigstillPlanServerAction(narmesteLederId, payload);
  }
  let t2;
  if ($[1] !== ferdigstillPlanAction) {
    t2 = function startFerdigstillPlanAction(payload_0) {
      startTransition(() => {
        ferdigstillPlanAction(payload_0);
      });
    };
    $[1] = ferdigstillPlanAction;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const startFerdigstillPlanAction = t2;
  let t3;
  if ($[3] !== error || $[4] !== isPendingFerdigstillPlan || $[5] !== startFerdigstillPlanAction) {
    t3 = {
      startFerdigstillPlanAction,
      isPendingFerdigstillPlan,
      error
    };
    $[3] = error;
    $[4] = isPendingFerdigstillPlan;
    $[5] = startFerdigstillPlanAction;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}